import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectMapTargetData } from '../../store/map/map.selectors'
import { useMapContext } from './MapContext'
import { acknowledgeMapZoom } from '../../store/map/mapSlice'

export default function useMapZoomHandler() {
  const { targetZoom } = useSelector(selectMapTargetData)
  const { map, interact } = useMapContext()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!map || !targetZoom) return

    dispatch(acknowledgeMapZoom())

    interact({ zoom: targetZoom })
  }, [map, targetZoom])
}
